<script lang="ts">
    import { IconX } from "@wa-icons";

    interface Props {
        dataTestId?: string;
        id?: string;
        bgColor?: string;
        hoverColor?: string;
        textColor?: string;
        size?: "xs" | "sm" | "md" | "lg";
        extraButtonClasses?: string;
        onclick?: (event: MouseEvent) => void;
    }

    let {
        dataTestId = undefined,
        id = undefined,
        bgColor = "bg-[var(--nutrivera-shell-raised)]",
        hoverColor = "bg-[var(--nutrivera-shell-hover)]",
        textColor = "text-[var(--nutrivera-shell-text)]",
        size = "lg",
        extraButtonClasses = "",
        onclick,
    }: Props = $props();

    let sizeClasses = $derived(
        size === "xs"
            ? "h-6 w-6 text-sm"
            : size === "sm"
              ? "h-8 w-8 text-base"
              : size === "md"
                ? "h-10 w-10 text-lg"
                : "h-12 w-12 text-2xl",
    );

    function handleClick(event: MouseEvent) {
        event.preventDefault();
        event.stopPropagation();
        onclick?.(event);
    }
</script>

<button
    type="button"
    {id}
    class="{sizeClasses} close-window close-btn flex aspect-square items-center justify-center rounded-[9px] border border-solid border-[var(--nutrivera-shell-border)] p-0 text-2xl transition-colors hover:bg-[var(--nutrivera-shell-hover)] focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[var(--nutrivera-shell-accent)] {textColor} {bgColor} hover:{hoverColor} {extraButtonClasses}"
    data-testid={dataTestId}
    onclick={handleClick}
>
    <IconX />
</button>
